import {calculateEachWayValues} from "../../../helpers/eachWayBetHelpers";
import {usingNonDecimalCurrency} from "../../../helpers/localization";
import {MATCHDAY_MODULE_TYPE} from "../modules/matchday/constants/identifiers";

export function rcTotalStakeSingleEvent(store, betsToPlace, bet) {

    let placedBets;
    let openBets;
    if (bet.bets[0].game.type === MATCHDAY_MODULE_TYPE) {

        placedBets = store.getState().vpp.placedBets.filter((placedBet) => placedBet.Bets[0].Channel === bet.bets[0].event.channel
            && Number(placedBet.Bets[0].EventDetails.leagueDay) === bet.bets[0].event.leagueDay);

        openBets = betsToPlace.filter((openBet) =>
            openBet.bets[0].game.channel === bet.bets[0].event.channel && openBet.bets[0].event.leagueDay === bet.bets[0].event.leagueDay);
    } else {
        placedBets = store.getState().vpp.placedBets.filter((placedBet) => placedBet.Bets[0].Channel === bet.bets[0].event.channel
            && Number(placedBet.Bets[0].EventId) === bet.bets[0].event.eventId);

        openBets = betsToPlace.filter((openBet) =>
            openBet.bets[0].game.channel === bet.bets[0].event.channel && openBet.bets[0].event.eventId === bet.bets[0].event.eventId);

    }
    let totalStake = placedBets ? placedBets.reduce(function (a, b) {
        return Number(a) + Number(b.Bets[0].Stake);
    }, 0) : 0;

    totalStake = totalStake + (openBets ? openBets.reduce(function (a, b) {
        return Number(a) + Number(usingNonDecimalCurrency(store.getState().vpp.systemCurrency) ?
            b.bets[0].externalRefId !== undefined ? calculateEachWayValues(b.stake, Number(b.bets[0].market.odds), b.bets[0].event.eachWayRatio).totalStake : b.stake
            : b.bets[0].externalRefId !== undefined ? calculateEachWayValues(b.stake, Number(b.bets[0].market.odds), b.bets[0].event.eachWayRatio).totalStake * 100 : b.stake * 100);
    }, 0) : 0);

    return totalStake;
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/helpers/realityChecker.js